<template>
  <div class='main'>
    <div class="main_top">
      <div>
        <!-- <el-input
        class="search"
        placeholder="请输入内容"
        v-model="roleSearch"
        clearable
        size="small"
        @change="SearchChange"
      >
      </el-input> -->
      </div>
      <div>
        <Model
          type="role"
          msg="新增"
          icon="md-add"
          @roleDataList='getsroleDataList'
        ></Model>
        <Model
          msg="编辑"
          icon="ios-create"
          :roleItem="roleItem"
          @roleDataList='getsroleDataList'
        ></Model>
        <Button
          icon="md-trash"
          @click="delrole"
        >
          删除
        </Button>
        <Button
          icon="md-construct"
          @click="menuBtn"
        >
          菜单授权
        </Button>

        <Button
          icon="md-construct"
          @click="warrantBtn"
        >
          功能授权
        </Button>
      </div>
      <el-dialog
        :title="roleTitle"
        :visible.sync="dialogVisible"
        width="30%"
      >
        <el-tree
          :data="roleList"
          :props="props"
          :show-checkbox="true"
          :default-checked-keys="checkmodule"
          node-key="moduleid"
          ref="treeRef"
          @check-change="roleCheck"
        >
        </el-tree>
        <span
          slot="footer"
          class="dialog-footer"
          style="position:absolute;bottom:10px;right:10px;"
        >
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="SaveRoleModuleBtns"
          >确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="main_body">
      <el-table
        ref="singleTable"
        :data="roleDataList"
        highlight-current-row
        @current-change="roleChange"
        style="width: 100%"
        stripe
      >
        <el-table-column
          type="index"
          width="80"
          label="序号"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="rolecode"
          label="角色编号"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="rolename"
          label="角色名称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="description"
          label="描述"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="roletype"
          label="角色类型"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="createdate"
          label="创建时间"
          align="center"
        >
        </el-table-column>
      </el-table>
      <div>
        <el-pagination
          style="text-align:right;margin-top:20px;"
          :hide-on-single-page="true"
          :total="total"
          :page-size="pagesize"
          :current-page='currentpage'
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '../../api/index'
import Model from '../../components/jurisdiction/roleModal'

export default {
  data () {
    return {
      roleTitle: '',
      roleSearch: '',
      roleDataList: [],
      total: 100,//分页总条数
      pagesize: 13,//每页显示数
      currentpage: 1,//当前页
      roleItem: {},//角色选中项
      dialogVisible: false,
      props: {
        label: 'modulename',
        children: 'children',
      },
      roleList: [],//角色菜单
      checkmodule: [],//角色菜单选中项
      roleModelBtns: [],//角色菜单按钮授权集合
    }
  },
  components: {
    Model: Model
  },
  methods: {
    //搜索
    SearchChange (val) {
      console.log(val);
    },
    //角色表格选中项
    roleChange (val) {
      this.roleItem = val
    },
    //获取角色列表
    async GetDataList () {
      const res = await Api.role.GetDataList(this.currentpage, this.pagesize)
      if (!res.success) return this.$Message.error('获取角色列表失败!')
      this.roleDataList = res.rows;
      console.log(res);
    },
    getsroleDataList (data) {
      this.total = data.totle;
      this.roleDataList = data
    },
    handleCurrentChange (val) {
      this.currentpage = val;
      this.GetDataList()
    },
    //删除角色
    async delrole () {
      if (JSON.stringify(this.roleItem) == '{}') return this.$Message.info('请选择要删除的角色！')

      this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await Api.role.DelData([this.roleItem.roleid])
        console.log(res);
        if (res.success) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.GetDataList();
        }
        this.GetSchoolTreeList()
      }).catch(() => {

      });


    },

    //菜单授权
    async menuBtn () {
      if (JSON.stringify(this.roleItem) == '{}') return this.$Message.info('请选择要授权的角色！')
      const res = await Api.role.GetRoleDataTree(this.roleItem.roleid)
      if (res.success != true) return this.$Message.info(res.msg)
      console.log(res);
      this.roleTitle = '角色菜单授权'
      this.roleList = res.rows.module
      this.checkmodule = res.rows.checkmodule
      this.dialogVisible = true;
    },

    //操作授权按钮
    async warrantBtn () {
      if (JSON.stringify(this.roleItem) == '{}') return this.$Message.info('请选择要授权的角色！')
      this.roleTitle = '角色功能授权'
      const res = await Api.role.GetRoleModuleAndBtns(this.roleItem.roleid)
      this.roleList = res.rows.module
      this.checkmodule = res.rows.checkmodule
      this.dialogVisible = true;
    },

    //角色授权选项
    roleCheck (data, checked) {
      if (checked) {
        data.ischeck = checked
        this.roleModelBtns.push(data)
      }
    },
    async SaveRoleModuleBtns () {
      let moduleids = [...this.$refs.treeRef.getCheckedKeys()]
      let res
      if (this.roleTitle == '角色菜单授权') {
        const params = {
          roleid: this.roleItem.roleid,
          moduleids: moduleids
        }
        res = await Api.role.SaveRoleData(params);
        console.log(res);
      } else if (this.roleTitle == '角色功能授权') {
        const params = {
          roleid: this.roleItem.roleid,
          buttonids: moduleids
        }
        res = await Api.role.SaveRoleButtons(params);
        console.log(res);
      }
      if (res.success != true) return this.$Message.info(res.msg)
      this.dialogVisible = false;

    },

  }
}
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .main_top {
    display: flex;
    justify-content: space-between;
    height: 60px;
    padding: 15px 15px 0 15px;
    .search {
      width: 220px;
    }
    > div {
      display: flex;
      justify-content: space-between;
      > div {
        margin-right: 10px;
      }
      > button {
        margin-right: 10px;
      }
    }
  }
}
</style>